export default __webpack_public_path__ + "static/media/bloggers.c5c95a4b.png";